module.exports = __webpack_public_path__ + "static/media/gallery-logo.8a310cbb.png";